import usernameChange from "form/modal/username";
import { USERNAME_FORM } from "../constants";

export const ModalUsernameForm = usernameChange.createContainer(USERNAME_FORM);
